import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private sidebar: WritableSignal<boolean> = signal(true);

  constructor() { }

  get isCollapsed(){
    return this.sidebar();
  }

  toggle(){
    this.sidebar.update(el => !el);
  }

  show(){
    this.sidebar.set(false);
  }

  hide(){
    this.sidebar.set(true);
  }
}
